export const taskMessages = {
  TASK_INPUT_INVALID: '문제·답안·점수·기간과 승인 근거를 확인해 주세요. 점수는 만점 이내에서 소수 둘째 자리까지 입력할 수 있습니다.',
  TASK_NOT_FOUND: '과제를 찾을 수 없습니다. 최신 정보를 다시 확인해 주세요.',
  TASK_PRODUCT_UNAVAILABLE: '사용 중인 강좌를 선택해 주세요.',
  TASK_POOL_IMMUTABLE: '공개한 과제 후보와 조건은 수정할 수 없습니다.',
  TASK_POOL_STATE: '과제 공개 상태가 바뀌었습니다. 최신 정보를 확인해 주세요.',
  TASK_POOL_UNAVAILABLE: '현재 제공되는 과제를 확인할 수 없습니다. 운영 담당자에게 문의해 주세요.',
  TASK_OPENING_UNAVAILABLE: '확정·공개한 개설을 선택해 주세요. 과제 공개는 개설 공개 후 가능합니다.',
  TASK_SCORE_MISMATCH: '과제 만점은 개설의 활성 과제 수료 조건 만점과 같아야 합니다.',
  TASK_WINDOW_INVALID: '과제 제출 기간은 수강기간 안에 있어야 합니다.',
  TASK_WINDOW_UNAVAILABLE: '과제 제출 기간이 아니거나 공개가 중지되었습니다. 최신 정보를 확인해 주세요.',
  TASK_PROGRESS_REQUIRED: '과제에 필요한 진도 조건을 먼저 충족해 주세요.',
  TASK_ALREADY_SUBMITTED: '이미 제출한 과제입니다. 운영자가 반려한 경우에만 기간 내 다시 제출할 수 있습니다.',
  TASK_NOT_SUBMITTED: '현재 채점하거나 반려할 수 있는 제출 내역이 없습니다.',
  TASK_FILE_UNAVAILABLE: '본인 첨부파일을 확인할 수 없습니다. 파일을 다시 선택해 주세요.',
  TASK_VERSION_CONFLICT: '다른 요청에서 먼저 변경되었습니다. 입력 내용을 확인한 후 최신 정보를 불러와 주세요.',
  TASK_REQUEST_CONFLICT: '같은 요청 번호에 다른 내용이 사용되었습니다. 최신 처리 결과를 확인해 주세요.',
  TASK_SUBMISSION_CHANGED: '채점 대상 제출이 바뀌었습니다. 최신 제출 내용을 다시 확인해 주세요.',
  TASK_IDENTITY_TARGET_DENIED: '현재 제출 회차의 본인인증 대상이 아닙니다. 최신 정보를 다시 확인해 주세요.',
  FILE_SIZE_INVALID: '첨부파일은 1바이트 이상, 20MB 이하로 선택해 주세요.',
  FILE_TYPE_NOT_ALLOWED: '지원하는 문서 또는 이미지 파일을 선택해 주세요.',
  FILE_IN_USE: '제출에 사용된 첨부파일은 삭제할 수 없습니다.',
}
export const taskState = state => ({ REQUESTED: '제출 대기', SUBMITTED: '채점 대기', GRADED: '채점 완료', RETURNED: '반려 · 재제출 대기', OPEN: '제출 기간', CLOSED: '기간 종료', UPCOMING: '시작 예정', PAUSED: '일시 중지', DRAFT: '초안', PUBLISHED: '공개', ENROLLMENT_INACTIVE: '수강 종료' })[state] || state
export const taskTime = value => value ? new Date(value).toLocaleString('ko-KR', { timeZone: 'Asia/Seoul' }) : '—'
